import { useState, useEffect } from 'react';
import { PEAP_CONTENT } from '../../../utils/constants';
import ManagementTab from './navigationTabs/management';
import { Helmet } from 'react-helmet';
import Complainant from './Complaint';
import Peapapproval from './Approvals';
import Messaging from './Messaging';
import PendingSpecialist from './pendingSpecialist';
import ActiveSpecialist from './activeSpecialist';
import Topbar from '../../PulseSurvey/Topbar';
import { useSearchParams } from 'react-router-dom';
import Payment from './Payment/Payment';
import { SpecialistPageData } from '../../../utils/pageContent';
import UnderMaintenance from '../../userMaintenance';

function Specialist({ topbarShow = true }) {
  const [selectedContentType, setSelectedContentType] = useState(1);

  const [params] = useSearchParams();
  const page = params.get('page');

  useEffect(() => {
    if (page) {
      setSelectedContentType(parseInt(page));
    }
  }, [page]);

  return (
    <div className="relative lg:mb-[45px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{SpecialistPageData.metaTitle}</title>
      </Helmet>
      {topbarShow === true && <Topbar title={SpecialistPageData.metaTitle} />}
      <div className="rounded-b-[10px] bg-shoorah-ggg dark:bg-shoorah-darkBgColor dark:text-white">
        <div className="overflow-auto custom-scrollbar">
          <div className="w-full dark:border-shoorah-darkBorder">
            <ManagementTab
              PEAP_CONTENT={PEAP_CONTENT}
              selectedContentType={selectedContentType}
              setSelectedContentType={setSelectedContentType}
            />
            {selectedContentType === 1 && <ActiveSpecialist />}
            {selectedContentType === 2 && <PendingSpecialist />}
            {selectedContentType === 4 && <Complainant />}
            {selectedContentType === 5 && <Messaging />}
            {selectedContentType === 6 && <Peapapproval />}
            {selectedContentType === 7 && <Payment />}
          </div>
        </div>

        <div></div>
      </div>
    </div>
  );
}

export default Specialist;
